import React from "react";
import { Link } from "react-router-dom";

const AuthenticationRedirectPrompt = ({ option }) => {
  return (
    <div className="flex items-center justify-center text-neutral-600 text-sm pb-5">
      {option === "login" ? (
        <div>
          {`Already have a Dermi.ai account? `}
          <Link
            to={"/login"}
            className="font-semibold text-neutral-700 hover:text-blue-800 cursor-pointer"
          >
            Log in
          </Link>
        </div>
      ) : (
        <div>
          {`Don't have a Dermi.ai account? `}
          <Link
            to={"/email_registration"}
            className="font-semibold text-neutral-700 hover:text-blue-800 cursor-pointer"
          >
            Register
          </Link>
        </div>
      )}
    </div>
  );
};

export default AuthenticationRedirectPrompt;
